"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'login.password.placeholder': '输入密码',
};
